import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { IModel } from '../../../core/service/base/data.service';
import { Appendix } from '../appendix';
import { RentInvoicingOrderSettings } from './rent-invoicing-order-settings';
import { RentInvoicingOrderStatus } from './rent-invoicing-order-status';

export class RentInvoicingOrderDetails extends ModelBase implements IModel {
  appendixes: Appendix[] = [];
  createdByName: string;
  caption: string;
  createdAt: Date;
  startedAt: Date;
  completedAt: Date;
  errorMessage: string;
  autoAttest: boolean;
  scheduled: boolean;
  dueFrom: LocalDate;
  dueTo: LocalDate;
  settings: RentInvoicingOrderSettings = new RentInvoicingOrderSettings();
  status: RentInvoicingOrderStatus;
  invoiceCount: number;
  attestedInvoiceCount: number;
  leaseAgreementCaption: string;
  leaseAgreementId: string;
  invoicePeriods: { year: number; month: number }[];
  toString(culture?: string): string {
    return this.caption;
  }
}
